import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router'
import queryString from 'query-string'

import { ReactComponent as SearchIcon } from 'assets/icons/magnifier.svg'
import useDebounce from 'hooks/useDebounce'

const SearchBar = ({ searchQuery, handleSearch }) => {
  const [query, setQuery] = useState('')

  const history = useHistory()
  const searchInput = useRef()

  const [searchbarIsOpen, setSearchbarIsOpen] = useState(!isEmpty(searchQuery))

  const toggleSearchbarState = useCallback((value) => {
    setSearchbarIsOpen(value)
  }, [])

  const handleKeyActions = useCallback(
    ({ keyCode, metaKey }) => {
      const escapeKey = 27
      const cmdKey = metaKey
      const kKey = 75

      // eslint-disable-next-line no-unused-expressions
      if (keyCode === escapeKey && searchbarIsOpen) {
        toggleSearchbarState(false)
      }

      if (cmdKey && keyCode === kKey) {
        toggleSearchbarState(!searchbarIsOpen)
      }

      searchbarIsOpen && searchInput.current.focus()
    },
    [searchbarIsOpen, toggleSearchbarState],
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyActions)

    return () => window.removeEventListener('keydown', handleKeyActions)
  }, [searchbarIsOpen, handleKeyActions])

  const queryParams = queryString.parse(history.location.search)

  const itemsRoute = history.location.pathname === '/items'

  const handleInputChange = (event) => {
    // change
    !itemsRoute &&
      history.replace({
        pathname: history.location.pathname,
        search: `offset=${queryParams.offset}`,
      })

    setQuery(event.target.value)
  }
  const debouncedQuery = useDebounce(query, 300)

  useEffect(() => {
    handleSearch(debouncedQuery)
  }, [debouncedQuery])

  useEffect(() => {
    setQuery(searchQuery)
  }, [searchQuery])

  return (
    <div className="search-item">
      <label data-searchbar-is-open={searchbarIsOpen}>
        <SearchIcon />
        <input
          onChange={handleInputChange}
          onClick={() => toggleSearchbarState(true)}
          placeholder="Search..."
          ref={searchInput}
          type="text"
          value={query}
        />
        <span className="shortcut">⌘K</span>
      </label>
    </div>
  )
}

SearchBar.defaultProps = {
  searchQuery: '',
  handleSearch: () => {},
}

SearchBar.propTypes = {
  searchQuery: PropTypes.string,
  handleSearch: PropTypes.func,
}

export default SearchBar
